export const DEFAULT_LOCALIZED_IMAGES_SIZES = [
  { id: 'lg', value: 'large', minVw: '1200px' },
  { id: 'md', value: 'medium', minVw: '992px' },
  { id: 'sm', value: 'small', minVw: '768px' },
  { id: 'xs', value: 'xsmall', minVw: '0px' }
];

export const DEFAULT_LOCALIZED_IMAGES_FORMATS = ['webp', 'png'];

export const DEFAULT_LOCALIZED_IMAGES_RESOLUTIONS = ['1x', '2x'];

export const DEFAULT_LOCALIZED_IMAGES_DIRECTORY = 'shared';

export const DEFAULT_LOCALIZED_IMAGES_SIZES_ORDER = [
  'xl',
  'lg',
  'md',
  'sm',
  'xs'
];

export const DEFAULT_LOCALIZED_IMAGES_FORMATS_ORDER = ['webp', 'png', 'jpg'];
